import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }

import { computed, ref } from 'vue'
    import { boolCompare } from '@common/Common'
    import type { MeetingQuestionReviewReadModel, ScoringVoteEntry } from '@Evaluation/AlternativesSurveys/Domain/readmodels'
    import MeetingQuestionReviewDr from '@Evaluation/AlternativesSurveys/Components/MeetingQuestionReviewDr.vue'
    import MeetingQuestionReviewPc from '@Evaluation/AlternativesSurveys/Components/MeetingQuestionReviewPc.vue'
    import AlternativeDetailsDialog from '@Alternatives/Alternatives/Components/AlternativeDetailsDialog.vue'
    import { AlternativeDetailsDialogViewModel } from '@Alternatives/Alternatives/Components/AlternativeDetailsDialog'
    import CriterionDetailsDialog from '@Criteria/Hierarchies/Components/CriterionDetailsDialog.vue'
    import { CriterionDetailsDialogViewModel } from '@Criteria/Hierarchies/Components/CriterionDetailsDialog'

    /* ---------------- props / emits ---------------- */

    
export default /*@__PURE__*/_defineComponent({
  __name: 'MeetingQuestionReview',
  props: {
    propRm: {},
    propIsMeetingManager: { type: Boolean }
  },
  emits: ["update-vote-value", "update-vote-comment"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    /* ---------------- shortcuts ---------------- */

    const rm = computed(() => props.propRm ?? null)
    const isMeetingManager = computed(() => props.propIsMeetingManager)

    /* ---------------- dialogs ---------------- */

    const alternativeDetailsDialog = ref(new AlternativeDetailsDialogViewModel())
    const criterionDetailsDialog = ref(new CriterionDetailsDialogViewModel())

    /* ---------------- derived state ---------------- */

    const contextName = computed(() => rm.value?.CriterionName ?? null)

    const votesEntries = computed<ScoringVoteEntry[]>(() =>
        [...(rm.value?.VotesEntries ?? [])].sort((a, b) =>
            boolCompare(a.SurveyId != null, b.SurveyId != null)
        )
    )

    const value = computed(() => rm.value?.Value ?? null)
    const comment = computed(() => rm.value?.Comment ?? null)

    const scaleLevels = computed(() => rm.value?.ScaleLevels ?? [])

    const alternativeName = computed(() => rm.value?.AlternativeName ?? null)
    const firstAlternativeName = computed(() => rm.value?.FirstAlternativeName ?? null)
    const secondAlternativeName = computed(() => rm.value?.SecondAlternativeName ?? null)

    /* ---------------- actions ---------------- */

    function showAlternativeDetails()
    {
        if (!rm.value) return
        alternativeDetailsDialog.value.show(
            rm.value.AlternativeName,
            rm.value.AlternativeDescription
        )
    }

    function showFirstAlternativeDetails()
    {
        if (!rm.value) return
        alternativeDetailsDialog.value.show(
            rm.value.FirstAlternativeName,
            rm.value.FirstAlternativeDescription
        )
    }

    function showSecondAlternativeDetails()
    {
        if (!rm.value) return
        alternativeDetailsDialog.value.show(
            rm.value.SecondAlternativeName,
            rm.value.SecondAlternativeDescription
        )
    }

    function showCriterionDetails()
    {
        if (!rm.value) return
        criterionDetailsDialog.value.show(
            rm.value.CriterionName,
            rm.value.CriterionPath,
            rm.value.CriterionDescription
        )
    }

    function updateVoteValue(val: number | null)
    {
        emit('update-vote-value', val)
    }

    function updateVoteComment(comment: string | null)
    {
        emit('update-vote-comment', comment)
    }

return (_ctx: any,_cache: any) => {
  return (rm.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(CriterionDetailsDialog, { viewModel: criterionDetailsDialog.value }, null, 8 /* PROPS */, ["viewModel"]),
        _createVNode(AlternativeDetailsDialog, { viewModel: alternativeDetailsDialog.value }, null, 8 /* PROPS */, ["viewModel"]),
        (rm.value.AlternativeId)
          ? (_openBlock(), _createBlock(MeetingQuestionReviewDr, {
              key: 0,
              propIsMeetingManager: isMeetingManager.value,
              propContextName: contextName.value,
              propValue: value.value,
              propComment: comment.value,
              propVotesEntries: votesEntries.value,
              propAlternativeName: alternativeName.value,
              propScaleLevels: scaleLevels.value,
              onShowAlternativeDetails: showAlternativeDetails,
              onShowCriterionDetails: showCriterionDetails,
              onUpdateVoteValue: updateVoteValue,
              onUpdateVoteComment: updateVoteComment
            }, null, 8 /* PROPS */, ["propIsMeetingManager", "propContextName", "propValue", "propComment", "propVotesEntries", "propAlternativeName", "propScaleLevels"]))
          : _createCommentVNode("v-if", true),
        (!rm.value.AlternativeId)
          ? (_openBlock(), _createBlock(MeetingQuestionReviewPc, {
              key: 1,
              propIsMeetingManager: isMeetingManager.value,
              propContextName: contextName.value,
              propValue: value.value,
              propComment: comment.value,
              propVotesEntries: votesEntries.value,
              propFirstAlternativeName: firstAlternativeName.value,
              propSecondAlternativeName: secondAlternativeName.value,
              onShowFirstAlternativeDetails: showFirstAlternativeDetails,
              onShowSecondAlternativeDetails: showSecondAlternativeDetails,
              onShowCriterionDetails: showCriterionDetails,
              onUpdateVoteValue: updateVoteValue,
              onUpdateVoteComment: updateVoteComment
            }, null, 8 /* PROPS */, ["propIsMeetingManager", "propContextName", "propValue", "propComment", "propVotesEntries", "propFirstAlternativeName", "propSecondAlternativeName"]))
          : _createCommentVNode("v-if", true)
      ]))
    : _createCommentVNode("v-if", true)
}
}

})